export default __webpack_public_path__ + "static/media/icono-vivaro-digital.a8ab2970.svg";